<script lang="ts">
import { game } from "./game.ts"
import { match } from "./match.ts"
export let visible
export let toggleInfo

let counts = $game.query_getCounts();


let exampleTarget = "стиль"
let exampleClues
let exampleAttempts = ["сутки", "свита", "стерх", "стиль"].map((w) => {
     return {
         letters: w.split(""),
         clues: match(w, exampleTarget)
     }
})
let exampleExplanation = [
  "<strong>с</strong> стоит на своем месте; <strong>т</strong> и <strong>и</strong> есть, но на других позициях",
  "<strong>т</strong> есть в слове, но не там; <strong>и</strong> встала на своё место",
  "<strong>т</strong> встала на своё место",
  "Угадано!"
]

const clueClasses = ["unknown", "not-here", "present", "exact"];
</script>

<section class="info" class:visible={visible}>
    <button class="btn" on:click={toggleInfo}>К игре</button>
    <div class="wrapper">
        <h2>Словль</h2>
        <p>В этой игре нужно угадать слово из 5 букв за 6 попыток.</p>
        <h3>Правила</h3>
        <p>После каждой попытки для каждой буквы видны подсказки:</p>
        <ul>
            <li>Если это правильная буква и она стоит на правильном месте, то она будет зелёной.</li>
            <li>Если эта правильная буква, но на <em>неправильном месте</em> &mdash; оранжевой.</li>
            <li>Если этой буквы вообще нет в этом слове, то она будет чёрной.</li>
        </ul>

        <p>На примере (загадано слово <span class="example-word">{exampleTarget}</span>):</p>

        <div class="board">
            {#each exampleAttempts as a, i}
                <div class="row-with-explanation">
                    <div class="row">
                        {#each a.letters as letter, letterIdx}
                            <div class="letter {clueClasses[a.clues[letterIdx]]}">{letter}</div>
                        {/each}
                    </div>
                    <div class="explanation">{@html exampleExplanation[i]}</div>
                </div>
            {/each}
        </div>
        
        <p>Пока в словаре игры мало слов ({counts.original}<sub>бандл</sub>{#if counts.local > 0}&nbsp;+ {counts.local}<sub>локально</sub>{/if}{#if counts.remote}&nbsp;+ {counts.remote}<sub>API</sub>{/if}). Кнопка &laquo;Добавить&raquo; добавляет в локальный словарь и отправляет на сервер (где Тим через Апрувль проверяет, что это настоящее слово для включения в бандл), а само слово сразу засчитывается.</p>
        
        <p>Это клон <a href="https://powerlanguage.co.uk/wordle/">Wordle</a> и <a href="https://foldr.moe/hello-wordl">Hello Wordl</a>, но на русском языке.</p>
        <p>Приходите в канал: <a href="https://t.me/slovl_game">@slovl_game</a>. Сделал <a href="https://timmarinin.net">Тим</a> (<a href="https://twitter.com/timmarinin">@timmarinin</a>), об ошибках и идеях можно писать в твиттер или на почту <a href="mailto:mt@marinintim.com">mt@marinintim.com</a>.</p>
        <details>
            <summary>Что нового (0.4 от 24 января 2022)</summary>
            <ul>
                <li>24 января
                    <ul>
                        <li>Словль дня: одно слово на день на всех! Понять, что вы в Словле дня можно по заголовку Словль №1. Следующее слово будет из Рандома</li>
                        <li>В эмоджи-текст добавлена ссылка на то же слово: работает и для словля дня, и для рандома (по идее!)</li>
                        <li>В эмоджи-текст словля дня включён хэштег #slovl_day1, чтобы можно было легко найти людей, решавших тот же словль дня</li>
                        <li>Поиграл шрифтами: добавил Inter</li>
                        <li>Поиграл стилями: чуть более уэс-андерсеновские-цвета</li>
                        <li>Обновил словарь загадываемых слов до 1346 слов</li>
                    </ul>
                </li>
                <li>15 января
                    <ul>
                        <li>Новый рендеринг на SVG: должно работать и на маленьких экранах</li>
                    </ul>
                </li>
                <li>10 января
                    <ul>
                        <li>слова, которые добавляете в словарь, не загадываются (до включения их в бандл)</li>
                        <li>контролируемый рандом и пермутации: слова не должны повторять до 400 раз (если не рефрешить страницу)</li>
                        <li>буквы теперь в клавиатурном порядке</li>
                        <li>добавил API для быстрого обновления списка слов</li>
                        <li>важная кнопка &laquo;Эмоджи&raquo; позволяет скопировать ваш результат сразу в буфер обмена</li>
                        <li>починил баг, где слова с повторяющимися буквами (напр., &laquo;пепел&raquo;) неправильно учитывались для подсказок, спасибо <a href="https://isqua.ru/">@isqua</a> и <a href="https://twitter.com/abatickaya">@abatickaya</a></li>
                        <li>новый дизайн кнопочек и сообщений; не должно зумить при двух быстрых кликах на айфонах</li>
                    </ul>
                </li>
            </ul>
        </details>
        <details>
            <summary>Что использовано внутри</summary>
            <p>Использованы иконки из <a href="https://feathericons.com/">FeatherIcons</a>, словарь из codenames.me</p>
            <p>Svelte и его сторы</p>
            <p>Xorshift</p>
            <p>Шрифт Inter</p>
        </details>
    </div>
    
</section>

<style>
 .info {
     display: none;
 }

 .btn {
     display: inline-block;
     background: transparent;
     font-size: 12px;
 }

 .info.visible {
     padding: 1em;
     display: block;
     position: absolute;
     background: #fff8dc;
     top: 0;
     bottom: 0;
     left: 0;
     margin: auto;
     right: 0;
     z-index: 2;
     overflow-y: scroll;
 }

 .wrapper {
     max-width: 60em;
 }

 .board {
     max-width: 60em;
 }

 .row-with-explanation {
     display: flex;
     flex-wrap: wrap;
     justify-content: flex-start;
     align-items: center;
     gap: 8px;
     margin-bottom: 4px;
 }

 .row {
     display: flex;
     gap: 2px;
 }

 .letter {
     width: 1.25em;
     height: 1.25em;
     padding: 1em;
     color: #fff;
     text-align: center;
     text-transform: uppercase;
 }

 .unknown {
     background: transparent;
 }

 .present {
     background: orange;
 }

 .not-here {
     background: #333;
 }

 .exact {
    background: green;
 }

 .explanation {
     text-align: left;
     width: 20em;
 }

 .example-word {
     font-style: italic;
 }
</style>
